import { ApolloProvider } from "@apollo/client";
import { ErrorBoundary } from "@sentry/react";
import { setConfiguration } from "react-grid-system";
import { RouterProvider } from "react-router-dom";

import { DesignSystemProvider, Toast } from "@icg360/design-system";

import { GlobalProvider } from "components/root/global-provider";
import { SSDataStoreProvider } from "data/ss-data-store";
import { FullPageError } from "pages";
import "stylesheets/main.scss";
import {
  apolloClient,
  setMixpanelSuperProperties,
  trackEvent,
  useFlags,
} from "utils";

import { router } from "./router";

setConfiguration({
  breakpoints: [576, 768, 992, 1200, 1600],
  containerWidths: [540, 768, 970, 1200],
  maxScreenClass: "xl",
});

const Root = () => {
  const flags = useFlags();
  setMixpanelSuperProperties({
    featureFlags: Object.keys(flags).map((key) => `${key}/${flags[key]}`),
  });

  return (
    <ErrorBoundary
      fallback={() => <FullPageError />}
      onError={(error) => trackEvent("MSS Error", { error })}
    >
      <SSDataStoreProvider>
        <ApolloProvider client={apolloClient}>
          <DesignSystemProvider>
            <GlobalProvider>
              <App />
              <Toast />
            </GlobalProvider>
          </DesignSystemProvider>
        </ApolloProvider>
      </SSDataStoreProvider>
    </ErrorBoundary>
  );
};

const App = () => {
  return <RouterProvider router={router()} />;
};

export default Root;
